




















import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import gtChooseMedia from "./chooseMedia.vue";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { ProductChildren } from "@root/lib/mixins";

const productCreate = namespace("productCreate");
@Component({
  components: { gtChooseMedia }
})
export default class meidia extends Mixins(ProductChildren) {
  @productCreate.Getter propertiesData;
  @productCreate.Getter mediaData;
  @Prop({ default: false })
  isEdit!: boolean;
  @Prop({ default: false }) readonly;
  @productCreate.Action updateProduct;
  @productCreate.Action queryProductInfo;
  links = {};
  async handleSubmit(data) {
    this.links = data;
  }
  handleVaildate() {
    return new Promise((resolve, reject) => {
      resolve(this.links);
    });
  }
  handleNext() {
    let chooseMedia: any = this.$refs.chooseMedia;
    chooseMedia.handleSubmit();
  }
  handlePrev() {
    this.$emit("prev");
  }
  async getNewData() {
    let res = await this.queryProductInfo(this.propertiesData.productCode);
  }
}
